export function getImageFileFromUrl(url) {

    var index = url.lastIndexOf("/");
    var imageName = url.substring(index + 1,url.length);
    // imageName一定要带上后缀
    let p = new Promise((resolve) => {
        var blob = null;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader('Accept', 'image/jpeg');
        xhr.responseType = "blob";
        xhr.onload = () => {
            blob = xhr.response;
            let imgFile = new File([blob], imageName, { type: 'image/jpeg' });
            resolve(imgFile);
        };
        xhr.send();
    });
    return p;
}